// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__puTgs","spinnerInner1":"styles_spinnerInner1__diX6Z","spinnerInner2":"styles_spinnerInner2__p3wfi","spinnerInner3":"styles_spinnerInner3__KPexA"};